/**
 * Application name.
 */
export const PRODUCT_NAME = 'Beyond InSite';
